import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SwalService {
  constructor() {}

  /**
   * Affiche une alerte de succès
   */
  success(title: string, text?: string): Promise<any> {
    return Swal.fire({
      icon: 'success',
      title,
      text,
      confirmButtonColor: '#dc2626',
      confirmButtonText: 'OK',
    });
  }

  /**
   * Affiche une alerte d'erreur
   */
  error(title: string, text?: string): Promise<any> {
    return Swal.fire({
      icon: 'error',
      title,
      text,
      confirmButtonColor: '#dc2626',
      confirmButtonText: 'Réessayer',
    });
  }

  /**
   * Affiche une alerte d'avertissement
   */
  warning(title: string, text?: string): Promise<any> {
    return Swal.fire({
      icon: 'warning',
      title,
      text,
      confirmButtonColor: '#dc2626',
      confirmButtonText: 'OK',
    });
  }

  /**
   * Affiche une alerte d'information
   */
  info(title: string, text?: string): Promise<any> {
    return Swal.fire({
      icon: 'info',
      title,
      text,
      confirmButtonColor: '#dc2626',
      confirmButtonText: 'OK',
    });
  }

  /**
   * Affiche une confirmation avec boutons Oui/Non
   */
  confirm(title: string, text?: string): Promise<any> {
    return Swal.fire({
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    });
  }

  /**
   * Affiche une alerte de chargement
   */
  loading(title: string = 'Chargement...'): void {
    Swal.fire({
      title,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  /**
   * Ferme l'alerte de chargement
   */
  close(): void {
    Swal.close();
  }

  /**
   * Affiche une alerte personnalisée
   */
  custom(options: any): Promise<any> {
    return Swal.fire({
      confirmButtonColor: '#dc2626',
      ...options,
    });
  }
}
